import { useRef } from "react";

export const useIceRestartBackoff = () => {
  const attemptRef = useRef(0);

  const getDelay = () => {
    const base = Math.min(30_000, 2 ** attemptRef.current * 1000);
    const jitter = Math.random() * 500;
    attemptRef.current += 1;
    return base + jitter;
  };

  const reset = () => {
    attemptRef.current = 0;
  };

  const exhausted = () => attemptRef.current >= 6; // ~1 min max

  return {
    getDelay,
    reset,
    exhausted,
  };
};
